export default __webpack_public_path__ + "static/media/hillary.c2b2f6d5.png";